interface SupplyPart {
  quantity: number
  originalPriceNet: number
  unitCustomDiscount: number
  discountAmount: {
    gross: number
  }
}

export const getSupplyPartTotal = (part: SupplyPart, withDiscount = true) => {
  if (withDiscount) {
    return (part.originalPriceNet - part.discountAmount.gross / part.quantity - part.unitCustomDiscount) * part.quantity
  }
  return part.originalPriceNet * part.quantity
}

// Order supply parts store the quantity for every kit on the line. Orders placed before that stored the
// per-kit quantity, which rarely divides evenly by the kit quantity, so such values are used as is
// (mirrors OrderLine.get_quantity_per_kit on the backend).
export const getQuantityPerKit = (partQuantity: number, kitQuantity: number) =>
  kitQuantity && partQuantity % kitQuantity === 0 ? partQuantity / kitQuantity : partQuantity

// Price of ONE kit.
export const getSupplyPricePerKit = (supplyParts: SupplyPart[], kitQuantity: number, withDiscount = true) => {
  return supplyParts.reduce(
    (prevPart, currPart) =>
      prevPart +
      (getSupplyPartTotal(currPart, withDiscount) * getQuantityPerKit(currPart.quantity, kitQuantity)) /
        currPart.quantity,
    0
  )
}

export const createLinkAndDownloadFile = (url: string, fileName: string) => {
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName) //or any other extension
  if (typeof link.download === 'undefined') {
    link.setAttribute('target', '_blank')
  }
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export const downloadFile = async (
  link: string,
  beforeStart: () => void,
  onDone: () => Promise<void>,
  onError: (e) => void,
  showMessage: (msg: string, variant: 'warning' | 'success' | 'error') => void
): Promise<FileReader | void> => {
  try {
    beforeStart()
    const response = await fetch(link + '?json=true', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    const responseData = await response.json()
    if (responseData.url) {
      console.log('download file', responseData.url)
      createLinkAndDownloadFile(responseData.url, responseData.fileName || 'filename')
      onDone()
    } else if (responseData.message) {
      showMessage(responseData.message, responseData.variant || 'success')
    }
  } catch (e) {
    console.error(e)
    onError(e)
  }
}
